import classNames from "classnames";
import { toast, TypeOptions } from "react-toastify";

interface ToastOptions {
  title?: string;
  message: string;
  id?: string;
}

interface ToastContentProps extends ToastOptions {
  type: TypeOptions;
}

const TITLE_STYLES: Record<TypeOptions, string> = {
  error: "text-red-500",
  success: "text-green-500",
  warning: "text-yellow-500",
  info: "text-white",
  default: "text-white",
};

export const useCustomToast = () => {
  const ToastContent = ({ title, message, type }: ToastContentProps) => (
    <div>
      {title && (
        <p
          className={classNames("font-bold pr-1 text-base", TITLE_STYLES[type])}
        >
          {title}
        </p>
      )}
      <p>{message}</p>
    </div>
  );

  const showSuccessToast = ({ id, ...props }: ToastOptions) => {
    toast.success(<ToastContent {...props} type="success" />, { toastId: id });
  };

  const showErrorToast = ({ id, ...props }: ToastOptions) => {
    toast.error(<ToastContent {...props} type="error" />, { toastId: id });
  };

  const showWarningToast = ({ id, ...props }: ToastOptions) => {
    toast.warning(<ToastContent {...props} type="warning" />, {
      toastId: id,
    });
  };

  const hideAllToasts = toast.dismiss;

  return {
    showSuccessToast,
    showErrorToast,
    showWarningToast,
    hideAllToasts,
  };
};
